import React, {PureComponent} from 'react';
import autobind from 'autobind-decorator';

import {SurveyFormInputText} from './Inputs/SurveyFormInputText';
import {SurveyFormInputDate} from './Inputs/SurveyFormInputDate';
import {SurveyFormInputBoolean} from './Inputs/SurveyFormInputBoolean';
import {SurveyFormInputFile} from './Inputs/SurveyFormInputFile';
import {SurveyFormInputNumber} from './Inputs/SurveyFormInputNumber';
import {SurveyFormInputWebMap} from './Inputs/SurveyFormInputWebMap';
import {SurveyFormComposedInput} from './Inputs/SurveyFormComposedInput';
import {PermitSurveySection} from "../../Pages/ConservationActions/PermitSurveySection";

const mapping = {
    "text": SurveyFormInputText,
    "date": SurveyFormInputDate,
    "bool": SurveyFormInputBoolean,
    "file": SurveyFormInputFile,
    "number": SurveyFormInputNumber,
    "webmap": SurveyFormInputWebMap,
    "text_bool": (props) => <SurveyFormComposedInput
        Inputs={[
            <SurveyFormInputBoolean {...props} Validation={null} />,
            <SurveyFormInputText {...props} Validation={null} />
        ]}
        Validation={props.Validation}
    />,
    "date_bool": (props) => <SurveyFormComposedInput
        Inputs={[
            <SurveyFormInputBoolean {...props} Validation={null} />,
            <SurveyFormInputDate {...props} Validation={null} />
        ]}
        Validation={props.Validation}
    />,
    "file_bool": (props) => <SurveyFormComposedInput
        Inputs={[
            <SurveyFormInputBoolean {...props} Validation={null} />,
            <SurveyFormInputFile {...props} Validation={null} />
        ]}
        Validation={props.Validation}
    />,
    "text_file": (props) => <SurveyFormComposedInput
        Inputs={[
            <SurveyFormInputFile {...props} Validation={null} />,
            <SurveyFormInputText {...props} Validation={null} />
        ]}
        Validation={props.Validation}
    />,
    "permit_bool": (props) => {
        let { ConservationAction, Question } = props;

        let permitValidation = null;
        let ourConservationActionPermits = ConservationAction.ConservationActionPermits.filter((x) => x.Permit?.permitTypeId === Question.permitTypeId );

        if(ourConservationActionPermits.length > 0 && props.Answer?.valueBool !== 1) {
            permitValidation = "This answer should be 'Yes' since this Conservation Action has one or more of the specified permit type assigned."
        }
        
        let inputs = [
            <span>Is this permit needed?</span>,
            <SurveyFormInputBoolean
                OnChangeOverride={(props, value) => {
                    const { SurveyFormInput } = props || {};
                    SurveyFormInput?.Change?.(answer => {
                        answer.valueBool = value;
                        return answer;
                    });
                }}
                Validation={null}
                {...props}
            />
        ];

        //If the use picks yes for the bool let's show the permit stuff.
        if(props.Answer && props.Answer.valueBool === 1 || ourConservationActionPermits.length > 0) {
            inputs.push(
                <PermitSurveySection
                    {...props}
                />
            );
        }
        
        if (props.Answer && props.Answer.valueBool !== 1 && props.Answer.valueBool !== null) {
            //if the bool is anything, but yes or null, lets add a notes field.
            inputs.push(<span>Why?</span>);
            inputs.push(<SurveyFormInputText {...props} Validation={null} />);
        }

        //return composed input based on the conditional logic above.
        return <SurveyFormComposedInput
            Inputs={inputs}
            Validation={permitValidation ?? props.Validation}
        />;
    },
    "label": null,
};

export class SurveyFormInput extends PureComponent {
    @autobind
    getSurveyQuestionDataType() {
        const { Question, SurveyQuestionDataTypes } = this.props;

        //if we have a question
        if(Question && Question.surveyQuestionDataTypeId && SurveyQuestionDataTypes.length) {
            //find the datatype if we have it.
            return SurveyQuestionDataTypes.find((x) => x.surveyQuestionDataTypeId === Question.surveyQuestionDataTypeId);
        }

        return null;
    }

    render() {
        const dataType = this.getSurveyQuestionDataType();

        //if this data type is mapped to a component, Return it.
        if(dataType && mapping[dataType.code]) {
            const DynamicComponent = mapping[dataType.code];

            return <DynamicComponent {...this.props} SurveyQuestionDataType={dataType} />;
        }

        return null;
    }
}


